export default function NoData() {
  return (
    <div className="center-box">조회 조건에 해당하는 데이터가 없습니다.</div>
  );
}
